(function () {
  'use strict';

  function getActiveImageSrc() {
    // 1. Try active/selected carousel cell first
    const activeCell = document.querySelector(
      '.CP-main-carousel .carousel-cell.is-selected img, ' +
      '.CP-main-carousel .carousel-cell.active img'
    );
    if (activeCell) return activeCell.src;

    // 2. Fallback: first visible image in carousel
    const firstImg = document.querySelector('.CP-main-carousel .carousel-cell img');
    if (firstImg) return firstImg.src;

    return null;
  }

  function getActiveIndex() {
    const cells = document.querySelectorAll('.CP-main-carousel .carousel-cell');
    for (let i = 0; i < cells.length; i++) {
      if (cells[i].classList.contains('is-selected') ||
          cells[i].classList.contains('active')) return i;
    }
    return 0;
  }

  function buildPhotoSwipeItems() {
    const items = [];
    const cells = document.querySelectorAll('.CP-main-carousel .carousel-cell img');
    cells.forEach(function (img) {
      const src = img.getAttribute('src') || '';
      // Ensure we get the master/largest version from Shopify CDN
      const fullSrc = src
        .replace(/(_\d+x\d*|_\d*x\d+)(\.[\w]+)(\?.*)?$/, '$2$3')
        .replace(/(\.(jpg|jpeg|png|webp))(\?.*)?$/i, '_2048x2048$1');
      items.push({
        src: fullSrc,
        w: img.naturalWidth  > 100 ? img.naturalWidth  * 2 : 2048,
        h: img.naturalHeight > 100 ? img.naturalHeight * 2 : 2048
      });
    });
    return items;
  }

  function openPhotoSwipe(index) {
    if (!window.PhotoSwipe || !window.PhotoSwipeUI_Default) {
      console.warn('CP Zoom: PhotoSwipe not found on page.');
      return;
    }

    const pswpEl = document.querySelector('.pswp');
    if (!pswpEl) {
      console.warn('CP Zoom: .pswp element not found.');
      return;
    }

    const items = buildPhotoSwipeItems();
    if (!items.length) return;

    const options = {
      index          : index,
      bgOpacity      : 0.92,
      showHideOpacity: true,
      history        : false,
      shareEl        : false,
      fullscreenEl   : true,
      zoomEl         : true,
      tapToClose     : true,
      pinchToClose   : true
    };

    const gallery = new window.PhotoSwipe(
      pswpEl,
      window.PhotoSwipeUI_Default,
      items,
      options
    );
    gallery.init();
  }

  function init() {
    document.body.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-cp-zoom]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const index = getActiveIndex();
      openPhotoSwipe(index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();